<template>
  <div class="couponsDesc">
    <!-- 返回 开始 -->
 <!--   <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">卡券详情</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div> -->
    <!-- 返回 结束 -->
    <div class="couponsDesc_bg"></div>
    <!-- main start-->
    <div class="couponDescmin">
      <div class="coupondesc_main">
        <div class="title_box">
          <img class="title_leftimg" src="/static/newprojecticon/left.png" />
          <div class="title">{{showItem.product && showItem.product.name }}</div>
          <img class="title_rightimg" src="/static/newprojecticon/right.png" />
        </div>

        <!-- header start -->
        <div class="header greyColor">使用完服务向商家出示二维码</div>
        <!-- <div class="header greyColor">需要到相应平台进行兑换</div> -->
        <!-- header end -->
        <!-- 链接 -->
        <!-- <div class="coupons_mainnumbox">
           <div class="coupons_mainnum">https://baidu.com</div>
           <div class="coupons_mainnumtip">请点击</div>
         </div> -->
        <!-- 二维码 -->
        <img class="mainimg" :src="showItem.qr" />
        <div class="bold">{{ showItem.card_no }}</div>
        <div class="desc" style="font-size: 14px;">二维码、数字码</div>
        <!-- 兑换码 -->
        <!-- <div class="coupons_mainnumbox1">
          <div class="mainnum">ABSCDHSNHXN</div>
           <div class="desc">兑换码、数字码</div>
        </div> -->
        <!-- <div class="redColor">30分钟</div>有效，无效请重新获取 -->
        <!-- <div class="coupon_card_num">仅用于：粤T12345</div> -->
        <div v-if="showItem.car_no" class="coupon_card_num">仅用于：{{showItem.car_no}}</div>
        <div class="horizontalLine">
          <div class="remark1" v-if="showItem.c_remark">{{showItem.c_remark}}</div>
          <div class="remark" style="white-space: pre-wrap;text-align: left;" v-if="showItem.product.detail">{{showItem.product.detail}}</div>
          <div class="remark" v-else>应发券方要求，现部分服务使用后商家可能会要求拍摄施工图，且同类型服务券，三天内只能核销一张，感谢您的配合</div>

          <!-- <div class="remark">应发券方要求，现部分服务使用后商家可能会要求拍摄施工图，且同类型服务券，三天内只能核销一张，感谢您的配合</div>
 -->
          <!-- <button class="weui-btn" type="primary" @click="toServiceList(showItem.product_id)" id="toServiceList"
            :disabled="buttonClicked" :data-product_id="showItem.product_id">查看服务商家</button> -->
          <div class="page_button coupondesc_button" @click="toServiceList(showItem.product_id,showItem.store_id)">
            <div class="page_zhifu">查看服务商家</div>
          </div>
        </div>
      </div>
      <!-- 注意事项 -->
      <!-- <div class="coupons_mesg">
        <div class="coupons_mesgtitlebox">
          <img class="coupons_mesgtitleimg" src="/static/newprojecticon/title.png"/>
          <div class="coupons_mesgtitletext">注意事项</div>
        </div>
        <div class="coupons_mesgmine">1.登录滴滴出行APP，点击左上角的“小人头”，进入个人中心。 2.点击向上的小箭头，进入隐藏的操作栏。 3.点击“兑换码”一项，输入兑换码，点击“兑换”。 4.回到个人中心操作栏，在“钱包”一栏中可以查看自己所兑换 的优惠券。 5.只能抵扣兑换之后生成的订单，支付订单时会默认使用优惠券 ，优惠券不拆分、不找零，不叠加，请合理选择是否使用优惠 券，如所在地无专车服务，请勿下单专车，下单兑换后无法退 回！快车券、专车券请勿选择拼车。此券只支持国内使用，仅 限在中文状态下使用。</div>
      </div> -->
    </div>


  </div>
</template>

<script>
  import httper from '../../api/http';
  export default {
    data() {
      return {
        id: '', // 上一页获取的卡券编号,默认为空
        showItem: {}, // 接口获取的卡券详情,默认为空
        buttonClicked: false, // 防止用户重复点击
        CardDetail: {},
        stop:true,
        card_no:"",
      }
    },
    created() {
     // let card_no = this.getParameterByName('card_no')
     let card_no = this.getQueryString('card_no')
      console.log("2222",card_no)
     this.request("getCouponDetail",{
       card_no:card_no
     })
      // this.id = this.$route.query.id ? Number(this.$route.query.id) : ''
      // if (this.$route.query.CardDetail) {
      //   this.CardDetail = this.$route.query.CardDetail
      // } else {
      //   this.CardDetail = {}
      // }
      // this.id = this.$route.query.id ? Number(this.$route.query.id) : ''
    },
    mounted() {
      // if (!this.id) return
      // let requestData = {
      //   id: this.id
      // }
      // this.request('getCouponDetail', requestData)
    },
    methods: {
      // pageReturn() {
      //   this.$router.go(-1)
      // },
      // pageToIndex() {
      //   this.$router.push({
      //     path: "/"
      //   })
      // },
      getParameterByName(name) {
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regexS = "[\\?&]" + name + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(window.location.search);
        if (results == null) {
          return "";
        } else {
          return decodeURIComponent(results[1].replace(/\+/g, " "));
        }
      },
      getQueryString(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        if (window.location.hash.indexOf("?") < 0) return null;
        let r = window.location.hash.split("?")[1].match(reg);
        if (r != null) return decodeURIComponent(r[2]);
        return null;
      },
      //跳转到服务商家页面
      toServiceList(product_id, store_id) {
        this.$router.push({
          path: '/storelist',
          query: {
            product_id: product_id
          }
        })
        // if (this.showItem.product.name == "车辆送检") {
        //   this.$router.push({
        //     path: '/yuyuetip',
        //     query: {
        //       coupon: this.showItem
        //     }
        //   })
        // } else if (store_id) {
        //   this.$router.push({
        //     path: '/serviceDesc',
        //     query: {
        //       product_id: product_id,
        //       store_id: store_id
        //     }
        //   })
        // } else {
        //   this.$router.push({
        //     path: '/serviceList',
        //     query: {
        //       product_id: product_id
        //     }
        //   })
        // }
      },
      toOrderDetail() {
        var order_param = {} //下单参数
        let that = this
        Dialog.confirm({
            title: '提示',
            message: '确认兑换卡券?',
          })
          .then(() => {
            order_param.amount = this.CardDetail.related.amount
            order_param.type = 'online'
            order_param.product_type = 3
            order_param.product_item_id = this.CardDetail.product_item_id
            order_param.recharge_number = 0
            order_param.pay_type = 'coupon'
            order_param.coupon_id = that.CardDetail.id
            console.log("queren")
            that.request('YeunifiedOrder', order_param)
          })
          .catch(() => {
            console.log("quxiao")
            return false;
          });
      },
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        let data = {}
        switch (type) {
          // 获取卡券详情
          case 'getCouponDetail':
            httper.get('ser-work/pack-detail', requestData, res => {
              if (res.code == 0) {
                this.showItem = res.data
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            },false)
            break
            //卡券兑换
          case 'YeunifiedOrder':
            httper.post('/payment/unified-order', requestData, res => {
              if (res.code == 0) {
                this.$router.push({
                  path: "orderListDetail",
                  query: {
                    id: res.data.order_no
                  }
                })
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
        }
      }
    }
  }
</script>

<style scoped>
  /* header */


  .header {
    margin-top: 10px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(187, 187, 187, 1);
    text-align: center;
  }

  /* main */
  .main {
    /*    padding: 20px; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-image: url(../../../static/erweimabg.png);
    background-size: 100% 100%;
    margin: 0 22px 40px 22px;
    width: 90%;
    height: 400px;
    /*    position: absolute;
    top: 35%;
    left: 9%; */
  }

  .coupondesc_main {
    padding: 20px;
    padding-bottom: 40px;
    padding-top: 46px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    box-sizing: border-box;
    align-items: center;
    background-image: url(../../../static/erweimabg.png);
    background-size: 100% 100%;
   /* margin: 0 22px 40px 22px; */
    width: calc(100% - 40px);
    margin: 0 20px 40px 20px;
  /*  height: 400px; */

  }

  .title {
    font-size: 12px;
    font-weight: bold;
    color: rgba(54, 54, 54, 1);
    line-height: 15px;
  }

  /*  .main img{
    width: 175px;
    height: 175px;
    margin: 7.5px 0;
  } */
  .mainimg {
    width: 115px;
    height: 115px;
    margin-top: 10px;
  }

  .coupondesc_main .bold {
    font-weight: bold;
    font-size: 12px;

    color: rgba(54, 54, 54, 1);
    margin-top: 10px;

  }

 /* .desc {
    font-size: 12px;

    font-weight: 400;
    color: rgba(54, 54, 54, 1);

  } */

  .coupon_card_num {}

  .coupondesc_main .redColor {
    color: red;
    font-weight: bold;
  }

  .coupondesc_main .horizontalLine {
    /*    width: 75vw;
    height: 1px;
    background-color: #F8F8F8;
    margin: 7.5px 0; */
    margin-top: 20px;

    /*  margin-top: 13%; */
  }

  /* .coupondesc_main .desc {
    font-size: 14px;
    width: 75vw;
    text-align: center;
  } */

  .coupondesc_main .weui-btn {
    width: 75vw;
    margin-top: 7.5px;
  }

  .couponsDesc_bg {
    width: 100%;
    height: 235px;
    /*    position: fixed; */
    background-image: url(../../../static/newprojecticon/erweimabg.png);
    background-size: 100% 100%;

  }
 /* .couponsDesc_bg1 {
    width: 100%;
    background-image: url(../../../static/gonggao.png);
    background-size: 100% 100%;
    height: 100%;
    position: absolute;
    top: 50px;
    bottom: 0;
    left: 0;
    right: 0;
    overflow-y: auto;
  } */
  .couponDescmin {
/*    width: 100%;
    background-color: #0398FF;
    position: fixed;
    background-size: cover;
    height: 100%; */

    width: 100%;
    /* background-color: #0398FF; */
    background-color: #FD8C00;
    /* position: fixed; */
    background-size: cover;
    height: 100%;
    padding-bottom: 30px;
  }

  .title_box {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .title_leftimg {
    width: 72px;
    height: 13px;
    margin-right: 10px;
  }

  .title_rightimg {
    width: 72px;
    height: 13px;
    margin-left: 10px;
  }

/*  .coupondesc_button {
    margin-top: 10px;
    height: 46px;
  } */
  .coupondesc_button {
      width: calc(100% - 20px);
      margin: 0 10px;
      margin-top: 10px;
      height: 46px;
      font-size: 14px;
  /*    position: fixed;
      bottom: 80px;
      right: 20px; */
    }
  .remark {
    font-size: 16px;
    margin-top: 10px;
    text-align: center;
  }

  .remark1 {
    border-bottom: 1px dashed #666666;
    padding-bottom: 10px;
    font-size: 16px;
    margin-top: 10px;
    text-align: center;
  }


  .couponsDesc {
    width: 100%;
    height: 100%;

  }

  .mainnum {
    font-size: 46px;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 5px;
  }

  .coupons_tip {
    font-size: 12px;
    color: #666666;
    margin-top: 20px;
  }

  .coupons_tip11 {
    font-size: 12px;
    color: #E35440;
  }

  .coupons_mainnumbox {
    margin: 60px 0 70px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .coupons_mainnumbox1 {
    margin: 20px 0 40px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .cardpay_button {
      /* margin-top: 20%; */
      width: calc(100% - 40px);
      margin: 20% 20px 0 20px;
    }

    .cardpay {
      width: 100%;
      height: 46px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #FFFFFF;
      font-size: 14px;
  /*    background: linear-gradient(90deg, #E96E56 0%, #E2523E 100%);
      box-shadow: 1px 4px 6px 2px rgba(234, 110, 86, 0.3); */
      background: #FD8C00;
      box-shadow: 0 5px 7px 2px rgba(253, 140, 0, 0.3);
      border-radius: 23px;
    }

  .coupons_mainnumtip {
    font-size: 15px;
    color: #666666;
  }

  .coupons_mainnum {
    font-size: 15px;
    color: #E35440;
  }

  .coupons_mesg {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    color: #FFFFFF;
  }

  .coupons_mesgtitlebox {
    width: 100%;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
  }

  .coupons_mesgtitleimg {
    width: 4px;
    height: 23px;
    margin-right: 10px;
  }

  .coupons_mesgtitletext {
    font-size: 14px;

  }

  .coupons_mesgmine {
    font-size: 13px;
  }

  .mainname {
    font-size: 30px;
    margin-top: 20px;
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/service/carddetail.vue